import { Typography } from "@mui/material";
import React from "react";
import { legend__text } from "../style";

export default function None() {
  return <Typography sx={legend__text}>NON</Typography>;
}
